import { useMemo } from 'react'

import { type BuildNavGroupsParams, buildNavGroups } from './sidebar-nav-groups-builder.util'
import type { SidebarNavGroup } from './sidebar-nav-item.interface'

export const useAppLayoutNavGroups = ({
  isPathActive,
  handleAgenciesSettings,
  handleCreateChat,
  agentActions,
  chatActions,
  chatEditState,
  pinnedConversationItemList,
  conversationItemList,
  agencyItemList,
}: BuildNavGroupsParams): SidebarNavGroup[] =>
  useMemo(
    () =>
      buildNavGroups({
        isPathActive,
        handleAgenciesSettings,
        handleCreateChat,
        agentActions,
        chatActions,
        chatEditState,
        pinnedConversationItemList,
        conversationItemList,
        agencyItemList,
      }),
    [
      isPathActive,
      handleAgenciesSettings,
      handleCreateChat,
      agentActions,
      chatActions,
      chatEditState,
      pinnedConversationItemList,
      conversationItemList,
      agencyItemList,
    ]
  )
